import { Delete as DeleteIcon, Edit as EditIcon } from '@material-ui/icons';
import MaterialTable from 'material-table';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';


const PointsTable = ({ createPoint, deletePoint, editPoint, getPoints, loading, points }) => {
    let columns;let actions;
    const auth = useSelector((state) => state.auth);
    if(auth.valitadion.crudCompleto === 'True'){
        columns = {columns: [
            { field: 'id', title: 'Identificador' },
            { field: 'nombre', title: 'TWS' },
            { field: 'latitud', title: 'Latitud' },
            { field: 'longitud', title: 'Longitud' },
            { field: 'cliente', title: 'Cliente' },
            { field: 'zona', title: 'Zona' },
            { field: 'sat', title: 'SAT' },
        ]};
        actions={ actions:[
            {
                isFreeAction: true,
                icon: 'refresh',
                onClick: getPoints,
            },
            {
               
                isFreeAction: true,
                icon: 'add',
                onClick: createPoint,
            },
            {
                icon: () => <EditIcon color="action" />,
                onClick: (_, data) => editPoint(data.id),
            },
            {
                icon: () => <DeleteIcon color="action" />,
                onClick: (_, data) => deletePoint(data),
            },
        ]};
    }
    else if(auth.valitadion.crudCompleto === 'False'){
        columns = {columns: [
            { field: 'id', title: 'Identificador' },
            { field: 'nombre', title: 'TWS'},
            { field: 'latitud', title: 'Latitud'},
            { field: 'longitud', title: 'Longitud' },
        ]};
        actions={ actions:[
            {
                isFreeAction: true,
                icon: 'refresh',
                onClick: getPoints,
            },
            {
                icon: () => <EditIcon color="action" />,
                onClick: (_, data) => editPoint(data.id),
            },

        ]};        
    }          
    else if(auth.valitadion.crudCompleto === 'Parcial'){
        columns = {columns: [
            { field: 'id', title: 'Identificador' },
            { field: 'nombre', title: 'TWS'},
            { field: 'latitud', title: 'Latitud'},
            { field: 'longitud', title: 'Longitud' },
        ]};
        actions={ actions:[
            {
                isFreeAction: true,
                icon: 'refresh',
                onClick: getPoints,
            },
            {
               
                isFreeAction: true,
                icon: 'add',
                onClick: createPoint,
            },
            {
                icon: () => <EditIcon color="action" />,
                onClick: (_, data) => editPoint(data.id),
            },
        ]};       
    }    
    else if(auth.valitadion.crudCompleto === 'ParcialC'){
        columns = {columns: [
            { field: 'id', title: 'Identificador' },
            { field: 'nombre', title: 'TWS'},
            { field: 'latitud', title: 'Latitud'},
            { field: 'longitud', title: 'Longitud' },
        ]};
        actions={ actions:[
            {
                isFreeAction: true,
                icon: 'refresh',
                onClick: getPoints,
            },
            {
               
                isFreeAction: true,
                icon: 'add',
                onClick: createPoint,
            },
            {
                icon: () => <EditIcon color="action" />,
                onClick: (_, data) => editPoint(data.id),
            },
            {
                icon: () => <DeleteIcon color="action" />,
                onClick: (_, data) => deletePoint(data),
            },            
        ]};       
    }       
    else if(auth.valitadion.crudCompleto === 'Medio'){
        columns = {columns: [
            { field: 'id', title: 'Identificador' },
            { field: 'nombre', title: 'TWS'},
            { field: 'latitud', title: 'Latitud'},
            { field: 'longitud', title: 'Longitud' },
        ]};
        actions={ actions:[
            {
                isFreeAction: true,
                icon: 'refresh',
                onClick: getPoints,
            },
            {
                icon: () => <EditIcon color="action" />,
                onClick: (_, data) => editPoint(data.id),
            },
        ]};       
    }          
    
 return (

    <MaterialTable
        actions={actions.actions}

        columns={columns.columns}
        data={points}
        isLoading={loading}
        options={{ 
            padding: 'dense',
            pageSizeOptions: [10, 20,30,40,50,60,70],
            pageSize: 10,
        }}
        title="TWS"
        localization={{
            header: {
                actions: 'Acciones'
            },
            pagination:{
                labelRowsSelect: 'filas',
                firstAriaLabel: 'Primera página',
                firstTooltip: 'Primera página',
                previousAriaLabel: 'Página anterior',
                previousTooltip: 'Página anterior',
                nextAriaLabel: 'Página siguiente',
                nextTooltip: 'Página siguiente',
                lastAriaLabel: 'Ultima página',
                lastTooltip: 'Ultima página',
            },
            body:{
                emptyDataSourceMessage: 'No hay TWS',
            },
            toolbar: {
                searchPlaceholder: 'Buscar TWS'
            }
        }}
    /> )
    
    };//);

PointsTable.propTypes = {
    createPoint: PropTypes.func,
    deletePoint: PropTypes.func,
    editPoint: PropTypes.func,
    getPoints: PropTypes.func,
    loading: PropTypes.bool,
    points: PropTypes.arrayOf(PropTypes.object),
};


export default PointsTable;

